
import UMUM from "../../library/umum.js";
export default {
   data() {
      return {
         UMUM: UMUM,
         form: {
            id: null,
            users_id: null,
            nama_lengkap: '',
            nik: '',
            no_str: '',
            masa_berlaku_str: '',
            jabatan_fungsional: '',
            no_hp: '',
            email: '',
            foto_profil: null,
            foto_profil_url: '',
            surat_tugas: null,
            surat_tugas_url: '',
            file_str: null,
            file_str_url: '',
         },
         mdl_add: false,
         mdl_edit: false,
         mdl_hapus: false,
         btn_add: false,
         btn_edit: false,
         btn_hapus: false,
         file_path: this.$store.state.url.URL_APP + "uploads/",
         list_data: [],
         jml_data: 0,
         total_data: 0,
         page_first: 1,
         page_last: 0,
         page_limit: 10,
         cari_value: '',
         mdl_password: false,
         dataku: {
            users_id: null,
            username: '',
            password: '',
            confirmPassword: ''
         },
         errorMessage: '',
         mdl_lihat: false,
         lihatData: {
            id: null,
            users_id: null,
            nama_lengkap: '',
            nik: '',
            no_str: '',
            masa_berlaku_str: '',
            jabatan_fungsional: '',
            no_hp: '',
            email: '',
            foto_profil: '',
            surat_tugas: '',
            file_str: '',
            username: '',
         },
      };
   },
   methods: {
      getView() {
         const body = {
            page_limit: this.page_limit,
            data_ke: (this.page_first - 1) * this.page_limit,
            cari_value: this.cari_value,
         };

         fetch(this.$store.state.url.REGIS_ADMIN_BDRS + "getview", {
            method: "POST",
            headers: {
               "content-type": "application/json",
               authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(body)
         })
            .then(res => res.json())
            .then(res_data => {
               this.list_data = res_data.data;
               this.jml_data = res_data.jml_data;
               this.total_data = res_data.total_data;
               this.page_last = Math.ceil(this.total_data / this.page_limit);
            })
            .catch(err => {
               console.error("Error fetching data:", err);
               this.$q.notify({ type: "negative", message: "Gagal mengambil data admin_bdrs" });
            });
      },

      async addData() {
         try {
            if (this.dataku.password !== this.dataku.confirmPassword) {
               this.$q.notify({
                  type: 'negative',
                  message: 'Password dan konfirmasi password tidak sama!'
               });
               return;
            }
            if (this.dataku.password.length < 6) {
               this.$q.notify({
                  type: 'negative',
                  message: 'Password minimal 6 karakter!'
               });
               return;
            }

            this.btn_add = true;

            const formData = new FormData();

            formData.append('nama_lengkap', this.form.nama_lengkap);
            formData.append('nik', this.form.nik);
            formData.append('no_str', this.form.no_str);
            formData.append('masa_berlaku_str', this.form.masa_berlaku_str);
            formData.append('jabatan_fungsional', this.form.jabatan_fungsional);
            formData.append('no_hp', this.form.no_hp);
            formData.append('email', this.form.email);

            if (this.form.foto_profil) {
               formData.append('foto_profil', this.form.foto_profil);
            }
            if (this.form.surat_tugas) {
               formData.append('surat_tugas', this.form.surat_tugas);
            }
            if (this.form.file_str) {
               formData.append('file_str', this.form.file_str);
            }

            formData.append('username', this.dataku.username);
            formData.append('password', this.dataku.password);

            const response = await fetch(this.$store.state.url.REGIS_ADMIN_BDRS + "addAdminBdrs", {
               method: 'POST',
               body: formData,
               // headers tidak perlu content-type karena FormData otomatis mengatur
               headers: {
                  authorization: "kikensbatara " + localStorage.token
               }
            });

            const result = await response.json();

            if (response.ok && result.success) {
               this.$q.notify({
                  type: 'positive',
                  message: result.message || 'Data admin_bdrs berhasil ditambahkan!'
               });

               this.resetForm();
               this.mdl_add = false;
               this.getView();
               this.$emit('data-added');
            } else {
               throw new Error(result.message || 'Terjadi kesalahan saat menambah data');
            }
         } catch (error) {
            console.error('Error adding data:', error);
            this.$q.notify({
               type: 'negative',
               message: error.message || 'Gagal menambah data admin_bdrs!'
            });
         } finally {
            this.btn_add = false;
         }
      },

      resetForm() {
         this.form = {
            nama_lengkap: '',
            nik: '',
            no_str: '',
            masa_berlaku_str: '',
            jabatan_fungsional: '',
            no_hp: '',
            email: '',
            foto_profil: null,
            foto_profil_url: '',
            surat_tugas: null,
            surat_tugas_url: '',
            file_str: null,
            file_str_url: '',
         };
         this.dataku = {
            users_id: null,
            username: '',
            password: '',
            confirmPassword: ''
         };
      },

      async editData() {
         this.btn_edit = true;
         try {
            if (!this.form.nama_lengkap || !this.form.nik || !this.form.no_str || !this.form.masa_berlaku_str || !this.form.jabatan_fungsional) {
               throw new Error('Field wajib (Nama, NIK, No STR, Masa Berlaku STR, Jabatan) harus diisi!');
            }
            if (this.dataku.username && this.dataku.username.length < 6) {
               throw new Error('Username minimal 6 karakter jika diubah!');
            }

            const normalizedSTR = this.normalizeDate(this.form.masa_berlaku_str);

            const payload = {
               id: this.form.id,
               users_id: this.form.users_id,
               nama_lengkap: this.form.nama_lengkap,
               nik: this.form.nik,
               no_str: this.form.no_str,
               masa_berlaku_str: normalizedSTR,
               jabatan_fungsional: this.form.jabatan_fungsional,
               no_hp: this.form.no_hp,
               email: this.form.email,
               username: this.dataku.username || '',
            };

            const hasNewFoto = this.form.foto_profil && this.form.foto_profil instanceof File;
            const hasNewSurat = this.form.surat_tugas && this.form.surat_tugas instanceof File;
            const hasNewFileStr = this.form.file_str && this.form.file_str instanceof File;

            let response, result;

            if (hasNewFoto || hasNewSurat || hasNewFileStr) {
               const formData = new FormData();
               for (const key in payload) {
                  formData.append(key, payload[key] || '');
               }
               if (hasNewFoto) formData.append('foto_profil', this.form.foto_profil);
               if (hasNewSurat) formData.append('surat_tugas', this.form.surat_tugas);
               if (hasNewFileStr) formData.append('file_str', this.form.file_str);

               response = await fetch(this.$store.state.url.REGIS_ADMIN_BDRS + "editAdminBdrs", {
                  method: "POST",
                  headers: {
                     authorization: "kikensbatara " + localStorage.token
                  },
                  body: formData
               });
               result = await response.json();
            } else {
               response = await fetch(this.$store.state.url.REGIS_ADMIN_BDRS + "editAdminBdrs", {
                  method: "POST",
                  headers: {
                     "Content-Type": "application/json",
                     authorization: "kikensbatara " + localStorage.token
                  },
                  body: JSON.stringify(payload)
               });
               result = await response.json();
            }

            if (response.ok && result.success) {
               this.$q.notify({ type: "positive", message: result.message || "Data berhasil diupdate" });
               this.mdl_edit = false;
               this.getView();
            } else {
               throw new Error(result.message || "Gagal mengupdate data");
            }
         } catch (error) {
            console.error("Error edit data:", error);
            this.$q.notify({ type: "negative", message: error.message || "Terjadi kesalahan saat update data" });
         } finally {
            this.btn_edit = false;
         }
      },

      editModal(data) {
         this.form = {
            id: data.id,
            users_id: data.users_id,
            nama_lengkap: data.nama_lengkap || '',
            nik: data.nik || '',
            no_str: data.no_str || '',
            masa_berlaku_str: data.masa_berlaku_str || '',
            jabatan_fungsional: data.jabatan_fungsional || '',
            no_hp: data.no_hp || '',
            email: data.email || '',
            foto_profil: null,
            foto_profil_url: data.foto_profil ? (this.file_path + data.foto_profil) : '',
            surat_tugas: null,
            surat_tugas_url: data.surat_tugas ? (this.file_path + data.surat_tugas) : '',
            file_str: null,
            file_str_url: data.file_str ? (this.file_path + data.file_str) : '',
         };
         this.dataku.username = data.username || '';
         this.mdl_edit = true;
      },

      async hapusData() {
         this.btn_hapus = true;
         try {
            const response = await fetch(this.$store.state.url.REGIS_ADMIN_BDRS + "removeAdminBdrs", {
               method: "POST",
               headers: {
                  "Content-Type": "application/json",
                  authorization: "kikensbatara " + localStorage.token
               },
               body: JSON.stringify({
                  id: this.form.id,
                  users_id: this.form.users_id
               })
            });

            const res_data = await response.json();
            this.btn_hapus = false;

            if (response.ok && res_data.success) {
               this.mdl_hapus = false;
               this.getView();
               this.$q.notify({ type: 'positive', message: res_data.message || 'Data berhasil dihapus' });
            } else {
               this.$q.notify({ type: 'negative', message: res_data.message || 'Gagal menghapus data' });
            }
         } catch (error) {
            this.btn_hapus = false;
            this.$q.notify({ type: 'negative', message: 'Terjadi kesalahan saat menghapus data' });
            console.error('Error hapus data:', error);
         }
      },

      async editDataPassword() {
         this.errorMessage = '';

         if (!this.dataku.password || !this.dataku.confirmPassword) {
            this.errorMessage = "Password dan Confirm Password wajib diisi!";
            return;
         }

         if (this.dataku.password.length < 6) {
            this.errorMessage = "Password minimal 6 karakter!";
            return;
         }

         if (this.dataku.password !== this.dataku.confirmPassword) {
            this.errorMessage = "Password dan Confirm Password tidak sama!";
            return;
         }

         try {
            const res = await fetch(this.$store.state.url.REGIS_ADMIN_BDRS + "editPasswordAdminBdrs", {
               method: "POST",
               headers: {
                  "Content-Type": "application/json",
                  authorization: "kikensbatara " + localStorage.token
               },
               body: JSON.stringify({
                  users_id: this.dataku.users_id,
                  password: this.dataku.password
               })
            });

            const data = await res.json();

            if (res.ok && data.success) {
               this.$q.notify({ type: "positive", message: data.message || "Password berhasil diubah!" });
               this.mdl_password = false;
               this.dataku.password = '';
               this.dataku.confirmPassword = '';
            } else {
               this.errorMessage = data.message || "Gagal mengubah password!";
            }
         } catch (error) {
            console.error(error);
            this.errorMessage = "Terjadi kesalahan saat mengubah password.";
         }
      },

      indexing(idx) {
         return ((this.page_first - 1) * this.page_limit) + idx;
      },

      selectData(data) {
         this.dataku = {
            users_id: data.users_id,
            username: data.username || '',
            password: '',
            confirmPassword: ''
         };
         this.errorMessage = '';
         this.form = {
            id: data.id,
            users_id: data.users_id,
            nama_lengkap: data.nama_lengkap || '',
            nik: data.nik || '',
            no_str: data.no_str || '',
            masa_berlaku_str: data.masa_berlaku_str || '',
            jabatan_fungsional: data.jabatan_fungsional || '',
            no_hp: data.no_hp || '',
            email: data.email || '',
            foto_profil: null,
            foto_profil_url: data.foto_profil ? (this.file_path + data.foto_profil) : '',
            surat_tugas: null,
            surat_tugas_url: data.surat_tugas ? (this.file_path + data.surat_tugas) : '',
            file_str: null,
            file_str_url: data.file_str ? (this.file_path + data.file_str) : '',
         };
         this.lihatData = {
            id: data.id || null,
            users_id: data.users_id || null,
            nama_lengkap: data.nama_lengkap || '',
            nik: data.nik || '',
            no_str: data.no_str || '',
            masa_berlaku_str: data.masa_berlaku_str || '',
            jabatan_fungsional: data.jabatan_fungsional || '',
            no_hp: data.no_hp || '',
            email: data.email || '',
            foto_profil: data.foto_profil || '',
            surat_tugas: data.surat_tugas || '',
            file_str: data.file_str || '',
            username: data.username || '',
         };
      },

      normalizeDate(dateStr) {
         if (!dateStr || dateStr === '') return '';
         if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return dateStr;
         if (dateStr.includes('T')) return dateStr.split('T')[0];
         return '';
      },

      cari_data() {
         this.page_first = 1;
         this.getView();
      }
   },
   mounted() {
      this.getView();
   }
};
